import { DefaultState } from 'store/types';

export const VIEW_LODGING_OPTION_DATA_REQUEST = 'VIEW_LODGING_OPTION_DATA_REQUEST';
export const VIEW_LODGING_OPTION_DATA_SUCCESS = 'VIEW_LODGING_OPTION_DATA_SUCCESS';
export const VIEW_LODGING_OPTION_DATA_FAILURE = 'VIEW_LODGING_OPTION_DATA_FAILURE';

export interface ViewLodgingOptionData {
  location: {
    longitude: number,
    latitude: number
  },
  id: string,
  name: string,
  lodgingType: string,
  status: string,
  address: string,
  checkInDetails: string,
  checkOutDetails: string,
  notes: string,
  website: string,
  lodgingContact: {
    name: string,
    phoneNumber: string,
    email: string
  };
  likesCount: number;
  deleteEnabled: boolean;
  duplicateAddressExists?: boolean;
  activeReservationsCount: number;
  notesCount: number;
};

export type ViewLodgingOptionState = DefaultState & {
  contents?: ViewLodgingOptionData;
};

interface ViewLodgingOptionDataRequest {
  type: typeof VIEW_LODGING_OPTION_DATA_REQUEST;
};

interface ViewLodgingOptionDataSuccess {
  type: typeof VIEW_LODGING_OPTION_DATA_SUCCESS,
  contents: ViewLodgingOptionData;
}

interface ViewLodgingOptionDataFailure {
  type: typeof VIEW_LODGING_OPTION_DATA_FAILURE;
}

export type ViewLodgingOptionActionTypes = ViewLodgingOptionDataRequest | ViewLodgingOptionDataSuccess | ViewLodgingOptionDataFailure;